import React from 'react';

const ArrowsUp = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6334 11.2472C16.1453 11.7158 15.3538 11.7158 14.8656 11.2472L11.9995 8.49569L9.13339 11.2472C8.64524 11.7158 7.85378 11.7158 7.36562 11.2472C6.87747 10.7785 6.87747 10.0187 7.36562 9.5501L11.1156 5.9501C11.6038 5.48148 12.3953 5.48148 12.8834 5.9501L16.6334 9.5501C17.1216 10.0187 17.1216 10.7785 16.6334 11.2472Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6334 18.4513C16.1453 18.9199 15.3538 18.9199 14.8656 18.4513L11.9995 15.6998L9.13339 18.4513C8.64524 18.9199 7.85378 18.9199 7.36562 18.4513C6.87747 17.9826 6.87747 17.2229 7.36562 16.7542L11.1156 13.1542C11.6038 12.6856 12.3953 12.6856 12.8834 13.1542L16.6334 16.7542C17.1216 17.2229 17.1216 17.9826 16.6334 18.4513Z",
      fill: "currentColor"
    }
  )
);
ArrowsUp.displayName = "Icons.ArrowsUp";

export { ArrowsUp };
//# sourceMappingURL=ArrowsUp.js.map
